export CollapseContainer from './CollapseContainer';
export default from './Collapse';



// WEBPACK FOOTER //
// ./src/components/Collapse/index.js